import { ImNetWork } from "@/network/imNet/imNet";

//测试接口
export function IMTest() {
  return ImNetWork.post("IMTools.testNet");
}

//游客登录
export function imykLogin() {
  return ImNetWork.post("IMUser.guestLogin");
}

//手机号登录获取验证码
export function getPhoneCode(data: any) {
  return ImNetWork.post("IMTools.getValid", data);
}

//手机号验证码登录
export function doPhoneCodeLogin(data: any) {
  console.log('phone code login', data);

  return ImNetWork.post("IMUser.verifyLogin", data);
}

//手机号密码登录
export function doPasswordLogin(data: any) {
  return ImNetWork.post("IMUser.passwdLogin", data);
}

//账号密码登录
export function imFastLogin(data: any) {
  return ImNetWork.post("IMUser.fastLogin", data);
}


//账号密码登录
export function fnameLogin(data: any) {
  return ImNetWork.post("IMUser.fnameLogin", data);
}

//设置账号密码/昵称，
// $fname 6-20字母加数字 
// @param $passwd 6-20位字母数字常用字符 
// @param $nickname 6-20字母加数字（前后不允许有空格，空格数量3个以内）
export function setAccountInfo(data: any) {
  return ImNetWork.post("IMUser.setAccountInfo", data);
}

//检查是否有登录密码密码
export function checkPassword(data: any) {
  return ImNetWork.post("IMTools.getLoginPasswdState", data);
}

//设置密码
export function SetPassword(data: any) {
  return ImNetWork.post("IMTools.setLoginPassWD", data);
}

//修改密码
export function changePassword(data: any) {
  return ImNetWork.post("IMTools.modifyLoginPassWD", data);
}

//手机验证码修改密码
export function phoneChangePassword(data: any) {
  return ImNetWork.post("IMTools.forgetLoginPassWD", data);
}

//获取系统头像
export function getHeadList() {
  return ImNetWork.post("IMTools.getHeadList");
}

//点愉快收下的时候，发送IM消息
export function sendImMsg(data: any) {
  return ImNetWork.post("IMTools.sendChatMsg", data);
}

//聊天界面发送IM 图片消息
export function upload(data: any) {
  return ImNetWork.upload("upload/upload.php", data);
}

// 获取上传文件的url
export function uploadurl(data: any) {
  return ImNetWork.uploadurl("upload/upload.php", data);
}

//上报客户端错误日志
export function uploadClienterrorlog(data:any){
  return ImNetWork.post("IMTools.saveClienterrorlog",data);
}

//获取邮箱验证码
export function getValidByEmail(data:any){
  return ImNetWork.post("IMTools.getValidByEmail",data);
}

//忘记密码，重置密码
export function forgetPasswordByEmail(data:any){
  return ImNetWork.post("IMTools.forgetLoginPassByEmail",data);
}